<template>
	<div class="card mb-2"> 
		<div class="card-body">
			<div class="row p-0 pt-0 mt-0 border-bottom border-dark">
				<div class="col pl-1">
					{{ user.name }}
				</div>
			</div>


			<div class="row mt-2">
				<div class="col">
					<button class="btn btn-info" @click="poskytovateleActive = true" v-if="! poskytovateleActive"> Zobrazit poskytovatele </button>
					<button v-else class="btn btn-info" @click="poskytovateleActive = false"> Schovat poskytovatele </button>
				</div>
			</div>

			<div class="user-card-poskytovatele border-top border-bottom border-dark" v-show="poskytovateleActive"> 
				<div class="row mt-2 border-bottom" v-for="(poskytovatel, poskytIndex) of poskytovatele" :key="poskytIndex">
					<div class="col">
						<button v-if="! userHasPoskytovatel(poskytovatel, user.disabledPoskytovatele)" class="btn btn-success" @click="addToZakazano(poskytovatel)"> Zobrazuji </button>
						<button v-else class="btn btn-danger" @click="removeFromZakazano(poskytovatel)"> Nezobrazuji </button> 
					</div>
					<div class="col" style="line-height: 35px;">
						<div class="float-left"> {{ poskytovatel }} </div>
					</div>
				</div>
			</div>


			<div class="row mt-2">
				<div class="col">
					<button class="btn btn-info" @click="pravomoceActive = true" v-if="! pravomoceActive"> Zobrazit pravomoce </button>
					<button v-else class="btn btn-info" @click="pravomoceActive = false"> Schovat pravomoce </button>
				</div>
			</div>

			<div class="user-card-powers border-top border-bottom border-dark" v-show="pravomoceActive">
				<div class="row mt-2 border-bottom" v-for="(power, powerIndex) of powers" :key="powerIndex">
					<div class="col">
						<button v-if="userHasPower(user.powers, power.name)" class="btn btn-success" @click="deactivatePower(user, power.name)"> Aktivní </button>
						<button v-else class="btn btn-danger" @click="activatePower(user, power.name)"> Neaktivní </button> 
					</div>
					<div class="col" style="line-height: 35px;">
						<div class="float-left"> 
							{{ power.name === 'search-provider' ? 'vyhledávač' : (power.name === 'overovac' ? 'editor' : power.name) }} 
						</div>
					</div>
				</div>
			</div>

			<div class="row mt-2">
				<div class="col">
					<button class="btn btn-warning" @click="changePassword(user.id)"> Změnit heslo </button>
				</div>
			</div>

			<div class="row mt-2">
				<div class="col">
					<button v-if="user.active" class="btn btn-secondary" @click="changeUserStatus(user.id, user.name)"> 
						Deaktivovat 
					</button>
					<button v-else class="btn btn-info" @click="changeUserStatus(user.id, user.name)"> 
						Aktivovat
					</button>
				</div>
			</div>

			<div class="row mt-2">
				<div class="col">
					<button class="btn btn-danger" @click="deleteUser(user.name)"> 
						Smazat
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'


export default {
	name: 'UserCard',
    
    props: {
		user: Object,
		powers: Array,
		poskytovatele: Array,
    },

	data () {
		return {
			pravomoceActive: false,
			poskytovateleActive: false,
			testPoskytovatele: ['UPC'],
		}
    },

	methods: {
		async addToZakazano (spolecnost) {
			if (this.upravuji) {
				return
			}

			this.upravuji = true
			const id = this.user.id
			this.user.disabledPoskytovatele.push(spolecnost)
			await AdditionsService.addToZakazano(spolecnost, id) 
			this.upravuji = false
		},

		async removeFromZakazano (spolecnost) {
			if (this.upravuji) {
				return
			}

			this.upravuji = true
			const id = this.user.id

			this.user.disabledPoskytovatele = this.user.disabledPoskytovatele.filter(e => e !== spolecnost)
			await AdditionsService.removeFromZakazano(spolecnost, id) 

			this.upravuji = false
		},

        async changeUserStatus (id, name) {
			const myUser = localStorage.getItem('user')
			if (myUser === name) {
				return
			}
			const changed = await AdditionsService.changeUserStatus(id)
			if (changed.data) {
				this.$emit('fetchUsers')
			}
		},

		async deleteUser (user) {
			const pass = window.prompt('Zadej jméno mazaného účtu: ')
			if (pass === user) {
				const deleted = await AdditionsService.deleteUser(user)
				if (deleted) {
					this.$emit('fetchUsers')
				}
			}
			return
		},

		async deactivatePower (user, power) {
			let { powers, name } = user
			const myUser = localStorage.getItem('user')

			if (name === myUser && power === 'users') {
				return
			}

			if (! powers || powers.length < 1 || !  powers.includes(power)) {
				return
			} 
			
			let toRemoveIndex = powers.indexOf(power) 

			if (toRemoveIndex > -1) {
				powers.splice(toRemoveIndex, 1)
			}

			if (powers.length < 1) {
				powers = []
			}

			const deactivated = await AdditionsService.savePowers(name, powers)

			if (! deactivated) {
				return
			}


			if (deactivated.data[0].name === myUser) {
				this.$emit('newUserPowers', deactivated.data[0].powers)
			}

			this.$emit('updateUsers', deactivated.data[0])
		},

		async activatePower (user, power) {
			let { powers, name } = user

			if (powers && powers.length > 0 && powers.includes(power)) {
				return
			} else if (! powers || powers.length < 1) {
				powers = [power]
			} else {
				powers.push(power)
			}

			const activated = await AdditionsService.savePowers(name, powers)

			if (! activated) {
				return
			}

			const myUser = localStorage.getItem('user')

			if (activated.data[0].name === myUser) {
				this.$emit('newUserPowers', activated.data[0].powers)
			}
			this.$emit('updateUsers', activated.data[0])
		},

		userHasPower (uPowers, power) {
			if (uPowers && uPowers.includes(power)) {
				return true
			} else {
				return false
			}
		},

		userHasPoskytovatel (current, usersPoskytovatele) {
			return usersPoskytovatele.includes(current)
		},

		async changePassword (userId) {
			const prvni = window.prompt('Nové heslo')
			const druhe = window.prompt('Heslo znovu')

			if (prvni !== druhe) {
				window.alert('Hesla se neshoduji. Změna nebyla provedena.')
			} else {
				const change = await AdditionsService.changePassword(userId, prvni)

				if (change) {
					window.alert('Heslo změněno.')
				} else {
					window.aler('Někde nastala chyba.')
				}
			}
		},
	},
}
</script>
<style lang="stylus" scoped>

.user-card 
	display flex
	flex-direction column
	border 2px solid rgba(202, 202, 202, 0.534)
	background-color white
	border-radius 10px

.user-card-first 
	display flex
	flex-direction row

.user-card-id 
	padding-left 15px
	font-size 19px

.user-card-name 
	display flex
	flex-direction row

.name-name 
	font-weight bold
	font-size 20px
	margin-left 10px

.name-user-name 
	color rgb(71, 71, 71)
	font-weight bold
	font-size 28px
	margin-left 15px

.user-card-powers 
	display flex
	flex-direction column
	text-align left

.user-card-poskytovatele 
	display flex
	flex-direction column
	text-align left

.pravomoce-text 
	color black
	padding-left 5px
	font-weight bold
	font-size 20px
	margin-left 10px

.user-card-powers-input 
	padding-left 15px
	padding-right 15px
	display flex
	flex-direction row
	padding-top 10px
	padding-bottom 10px
	line-height 30px
	font-size 20px

.user-card-poskytovatele-input 
	padding-left 15px
	padding-right 15px
	display flex
	flex-direction row
	padding-top 5px
	padding-bottom 5px
	line-height 30px
	font-size 20px

.poskytovatel-info
	color gray
	font-size 14px

.poskyt-name
	margin-left 15px

.power-active 
	background-color #30ff6b
	padding-left 20px
	padding-right 20px
	border-radius 25px
	margin-left 10px
	font-size 16px
	cursor pointer

.power-inactive 
	background-color #f59e42
	padding-left 20px
	padding-right 20px
	border-radius 25px
	margin-left 10px
	font-size 16px
	cursor pointer

.user-card-actions 
	display flex
	flex-direction row
	margin-top 10px
	margin-bottom 5px
	padding-top 15px
	padding-bottom 10px

.user-card-active 
	margin-left auto
	padding-right 10px

.status-button-pravomoce
	background-color rgb(0, 204, 255)
	padding-left 30px
	padding-right 30px
	border-radius 20px
	color white
	font-weight bold
	cursor pointer
	width 250
	margin-left 15px

.status-button-password
	background-color #fcba03
	padding-left 30px
	padding-right 30px
	border-radius 20px
	color white
	font-weight bold
	cursor pointer
	width 200px
	margin-left 15px

.status-button-active 
	background-color rgb(1, 141, 134)
	padding-left 30px
	padding-right 30px
	border-radius 20px
	color white
	font-weight bold
	cursor pointer
	width 200px

.status-button-inactive 
	background-color gray
	width 200px
	padding-left 30px
	padding-right 30px
	border-radius 20px
	color white
	cursor pointer
	font-weight bold

.user-card-delete 
	background-color rgba(255, 0, 0, 0.664)
	margin-right 20px
	padding-right 15px
	padding-left 15px
	border-radius 20px
	font-weight bold
	color white
	cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/users/UserCard.vue